import React from "react";
import styled from "styled-components";

const FormInput = ({ type, text, name, value, onChange, onBlur, hasError }) => {
  return (
    <Input
      type={type}
      name={name}
      placeholder={text}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      hasError={hasError}
    />
  );
};

export const Input = styled.input`
  width: 300px;
  padding: 12px;
  border-radius: 5px;
  border: ${({ hasError }) => (hasError ? "2px solid red" : "none")};
  text-align: center;
  font-size: 16px;
  outline: none;
  margin: 0.5rem auto;
`;

export default FormInput;
